//export default class News {
//   constructor() {  
//     this.$sections = document.querySelectorAll('section.news');  
//   }
//}
//
//new News();

import Swiper, { Navigation } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';


document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.swiper', {
      // Optional parameters
      modules: [Navigation],
      direction: 'horizontal',
      slidesPerView: 1.5,
      spaceBetween: 10,
      loop: true,

      breakpoints: {
        1024: {
            slidesPerView: 2.5,
            spaceBetweenSlides: 10
        },
        1400: {
          slidesPerView: 3.5,
          spaceBetweenSlides: 10
        },
      },
    
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-custom-next',
      },
    });
  })